import { render, staticRenderFns } from "./UserSettingsAccessOptions.vue?vue&type=template&id=67a6fcf7&scoped=true&"
import script from "./UserSettingsAccessOptions.vue?vue&type=script&lang=ts&"
export * from "./UserSettingsAccessOptions.vue?vue&type=script&lang=ts&"
import style0 from "./UserSettingsAccessOptions.vue?vue&type=style&index=0&id=67a6fcf7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6fcf7",
  null
  
)

export default component.exports